module.exports = __webpack_public_path__ + "static/media/messages.c66ee6f6.svg";